import React, { useState } from "react";
import ActiveTableComponent from "../ActiveTableComponent";
import EntriesComponent from "../EntriesComponent";
import { NavLink } from "react-router-dom";
import PendingTableComponent from "../PendingTableComponent";
import { useSelector } from "react-redux";

function HostListComponent({ data, setLimit, activeTab }) {
  const [search, setSearch] = useState('');
  const role = useSelector((state) => state.login.adminInfo?.role);

  const getColumns = () => [
    {
      key: "id",
      header: "Properties Count",
      render: (value) => (
        <div className="flex justify-between max-w-fit min-w-[20px] truncate">
          <p>{value}</p>
        </div>
      ),
    },
    {
      key: "name",
      header: "Name",
      render: (value) => (
        <div className="flex justify-start min-w-[200px]">
          <p>{value}</p>
        </div>
      ),
    },
    {
      key: "email",
      header: "Email",
      render: (value) => (
        <div className="flex justify-between max-w-[300px] min-w-[250px]">
          <p>{value}</p>
          <img src="copy.svg" alt="copy" />
        </div>
      ),
    },
    {
      key: "mobile",
      header: "Mobile",
      render: (value) => (
        <div className="flex justify-start min-w-[100px]">
          <p>{value}</p>
        </div>
      ),
    },
    {
      header: "Action",
      render: (row) => (
        <td className="py-4 flex justify-between w-fit gap-4">
          <NavLink
            to={`/hostList/${row._id}`}
            className="bg-viewBlue p-1 px-4 rounded-[21px] text-white"
          >
            View
          </NavLink>
          <button className="bg-editGreen p-1 px-4 rounded-[21px] text-white">
            Edit
          </button>
          {role !== "support" && (
            <button className="bg-deleteRed p-1 px-4 rounded-[21px] text-white">
              Delete
            </button>
          )}
        </td>
      ),
    },
  ];

  if (search.length !== 0) {
    data = data.filter((entry) =>
      entry?.name.toLowerCase().includes(search.toLowerCase()) ||
      entry?.email.toLowerCase().includes(search.toLowerCase()) ||
      entry?.mobile.includes(search.toLowerCase())
    );
  }

  return (
    <div className="bg-white px-5 py-3">
      <EntriesComponent
        search={search}
        setSearch={setSearch}
        setLimit={setLimit}
      />

      {data && activeTab === 'Active Host List' && (
        <ActiveTableComponent
          name="host"
          data={data}
          columns={getColumns()}
          link="host"
          role={role}
        />

      )}

      {data && activeTab === 'Pending Hosts' && (
        <PendingTableComponent
          name="host"
          data={data}
          link="host"
        />
      )}
    </div>
  );
}


export default HostListComponent;
